import React from 'react';
import './style/region.css'
import affiches from '../image/affiches-parisiennes.svg'
import isere from '../image/essor-isere.svg'
import loire from '../image/essor-loire.svg'
import journal from '../image/journal-du-btp.svg'
import Semaine from '../image/semaine-idf.svg'
import moniteur from '../image/moniteur-seine-et-marne.svg'
import Patriote from '../image/patriote-beaujolais.svg'
import Régional from '../image/regional-salonais.svg'
import Républicain from '../image/republicain-uzes-gard.svg'
import Publications from '../image/nouvelles-publications.svg'
import Lyon from '../image/tout-lyon.svg'
import Travaux from '../image/travaux-publics-batiments-midi.svg'
import Var from '../image/var-information.svg'
import Vaucluse from '../image/vaucluse-hebdo.svg'
import regionlogo from '../image/regionlogo.png'

const RegionPage = () => {
  return (
    <div className="region-page">
      <div className="logo-container-wrapper">
        <div className="logo-container">
          <a href="/home/nouvelle-annonce">
          <img src={regionlogo} alt="Affiches Parisiennes" className="logo" />
          </a>
        </div>
      </div>

      <br />
      <div className="regions-section container">
        <h2 className='title-region d-flex justify-content-center'> Nos régions</h2>
        <div className="regions-list">
          <span className="region">Toutes les régions </span>
          <span className="region">Auvergne-Rhône-Alpes </span>
          <span className="region">Île-de-France</span> <br />
          <span className="region">Occitanie </span>
          <span className="region">Provence-Alpes-Côte d'Azur</span>
        </div>
      </div>

      <br />

      <div className="mt-3 journaux-section container">
        <h2 className='title-region d-flex justify-content-center'>Nos journaux</h2>
        <div className="journaux-list ">
          <img src={affiches} alt="Affiches Parisiennes" className="journal-logo" />
          <img src={isere} alt="L'Essor Isère" className="journal-logo" />
          <img src={loire} alt="L'Essor Loire" className="journal-logo" />
          <img src={journal} alt="Le Journal du Bâtiment" className="journal-logo" />
          <img src={Semaine} alt="La Semaine Île-de-France" className="journal-logo" />
          <img src={moniteur} alt="Le Moniteur de Seine-et-Marne" className="journal-logo" />
          <img src={Patriote} alt="Le Patriote" className="journal-logo" />
          <img src={Régional} alt="Le Régional" className="journal-logo" />
          <img src={Républicain} alt="Le Républicain" className="journal-logo" />
          <img src={Publications} alt="Les Nouvelles Publications" className="journal-logo" />
          <img src={Lyon} alt="Lyon" className="journal-logo" />
          <img src={Travaux} alt="Travaux" className="journal-logo" />
          <img src={Var} alt="Var" className="journal-logo" />
          <img src={Vaucluse} alt="Vaucluse" className="journal-logo" />
        </div>
      </div>
    </div>
  );
}

export default RegionPage;
